import request from '@/utils/request'

/**
 * 获取优惠券库存信息
 * @param {Object} params - 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function listCouponShopPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/couponShopPool.listCouponShopPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 赠送优惠券
 * @param {Object} data - 请求数据
 * @returns {Promise} 返回Promise对象
 */
export function sendGoldCount(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cart/sendGoldCount',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}